import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
//components
import { Visibility } from "components/Visibility";
import { VisibilityConditional } from "components/VisibilityConditional";
import { SidebarLabel, SidebarContainer, DropdownLink, LabelLink } from "./styles";
//interfaces
import { ISidebarItem } from "./interface";

const SidebarItem: FC<ISidebarItem> = (props) => {
  const { title, dropdownItemTitle, titleOnly, path, icon, iconOpened, iconClosed, target } = props;

  const [subnav, setSubnav] = useState(false);

  const dispatch = useDispatch();

  const showSubnav = () => setSubnav(!subnav);

  const renderLabel = () => (
    <SidebarLabel>{title}</SidebarLabel>
  );

  const renderLink = () => (
    <LabelLink to={`${path}`} onClick={() => dispatch({ type: 'CLOSE_CUSTOM_SLIDER' })}>
      <SidebarLabel>{title}</SidebarLabel>
    </LabelLink>
  );

  return (
    <>
      <SidebarContainer
        className="mb-3"
        data-testid="sidebar-container"
        onClick={showSubnav}
      >
        <div className="sidebar-image-div">
          {icon && <img src={icon} alt="" />}
          <VisibilityConditional
            condition={!titleOnly}
            firstOption={() => renderLabel()}
            secondOption={() => renderLink()}
          />
        </div>
        <div className="icon-div">
          <Visibility visible={subnav}>
            <img src={iconOpened} alt="" />
          </Visibility>
          <Visibility visible={!subnav}>
            <img src={iconClosed} alt="" />
          </Visibility>
        </div>
      </SidebarContainer>
      <Visibility visible={subnav && !titleOnly}>
        <DropdownLink className="mb-6" to={`${path}`} onClick={() => dispatch({ type: 'CLOSE_CUSTOM_SLIDER' })}>
          <SidebarLabel>{dropdownItemTitle}</SidebarLabel>
        </DropdownLink>
      </Visibility>
    </>
  );
};

export default SidebarItem;